import { render, staticRenderFns } from "./ParseForm.vue?vue&type=template&id=eda24450&scoped=true&"
import script from "./ParseForm.vue?vue&type=script&lang=js&"
export * from "./ParseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda24450",
  null
  
)

export default component.exports